import {memo} from "react"
import {Spin} from "antd"
import {useQuery} from "@tanstack/react-query"
import {useTranslation} from "react-i18next"
import {handleError} from "helpers"
import {sapCheckpointsService} from "services"
import {SapCheckpointChecksFilter, SapCheckpointChecksStats} from "types/settings/sap-checkpoint-check"
import styles from "./SapChecksStats.module.css"

type Props = {
    filter?: SapCheckpointChecksFilter
}

const EMPTY_STATS: SapCheckpointChecksStats = {
    studentsHitThisMonth: 0
}

function SapChecksStats({filter}: Props) {
    const {t} = useTranslation(["academics"])
    const {data, isFetching} = useQuery(
        ["sap-checkpoint-checks-stats", filter],
        () => sapCheckpointsService.getChecksStats(filter),
        {
            initialData: EMPTY_STATS,
            onError: handleError
        }
    )

    return (
        <div className={styles.stats}>
            <div className={styles.statsBox}>
                <span className={styles.statsTitle}>{t("academics.sapChecks.studentsHitThisMonth")}</span>
                <span className={styles.statsValue}>{data?.studentsHitThisMonth ?? 0}</span>
            </div>
            {isFetching ? (
                <div className={styles.loadingWrap}>
                    <Spin />
                </div>
            ) : null}
        </div>
    )
}

export default memo(SapChecksStats)
